export function applyPreferredLanguageToUser(user, preferredLang) {
  if (!user) {
    return user;
  }

  return {
    ...user,
    preferred_lang: preferredLang,
    content_language: preferredLang,
    language: preferredLang,
  };
}

export async function refetchAfterLanguageChange(queryClient) {
  await queryClient.invalidateQueries();
}
